/**
 * Utility class for handling multiple focus requirements.
 */
export default class ToastFocusUtil {
    constructor(callback) {
        this.callback = null;
        this.state = {};
        this.element = null;
        this.listeners = {
            pointerenter: () => this.setState({ hasPointer: true }),
            pointerleave: () => this.setState({ hasPointer: false }),
            focusin: () => this.setState({ hasFocus: true }),
            focusout: () => this.setState({ hasFocus: false })
        };
        this.callback = callback;
    }
    observe(element) {
        if (this.element) {
            throw new Error(`ToastFocusUtil already have an observed element`);
        }
        this.element = element;
        for (const key in this.listeners) {
            element.addEventListener(key, this.listeners[key]);
        }
    }
    disconnect() {
        if (!this.element) {
            return;
        }
        for (const key in this.listeners) {
            this.element.removeEventListener(key, this.listeners[key]);
        }
        this.element = null;
        this.state = {};
    }
    setState(stateChange) {
        const oldHasFocus = this.state.hasFocus || this.state.hasPointer;
        Object.assign(this.state, stateChange);
        const newHasFocus = this.state.hasFocus || this.state.hasPointer;
        if (oldHasFocus !== newHasFocus && this.callback) {
            this.callback(!!newHasFocus);
        }
    }
}
//# sourceMappingURL=ToastFocusUtil.js.map